<div class="ya-input-container">
  <div class="ya-input-wrapper">
    <div class="input-text">
      <ng-container *ngIf="inputType==='password'; then passwordTemplate else inputTemplate"></ng-container>
      <ng-template #passwordTemplate>
        <input a11y_Input #CustomInput [type]="!registerPasswordVisibility ? 'password' : 'text'"
          [attr.maxlength]="inputMaxLength" [placeholder]="setPlaceholder()" class="ya-input-text" (blur)="onBlur()"
          (keyup)="handleKeyup($event)" (input)="onInputChange()">
      </ng-template>
      <ng-template #inputTemplate>
        <input a11y_Input #CustomInput [type]="inputType" [attr.maxlength]="inputMaxLength"
          [placeholder]="setPlaceholder()" class="ya-input-text" (blur)="onBlur()" (keydown)="handleKeyDown($event)"
          (keyup)="handleKeyup($event)" (input)="onInputChange()">
      </ng-template>
    </div>
    <ng-container *ngIf="inputType==='password'">
      <div class="password-visibility">
        <div (click)="registerPasswordVisibility = !registerPasswordVisibility" class="inline-icon"
          [inlineSVG]="!registerPasswordVisibility ? 'shop-icons.svg#ya-visibility-off' : 'shop-icons.svg#ya-visibility'">
        </div>
      </div>
    </ng-container>
    <ng-content></ng-content>
  </div>
</div>